import React, { useState, useEffect } from "react";
import axios from "axios";
import { MDBCol, MDBContainer, MDBRow, MDBBtn } from "mdb-react-ui-kit";
import Skeleton from "@mui/material/Skeleton";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// config
import configData from "../../../config/config.json";
//
import "../business.css";
// components
import MetaTagsBusinessOwners from "../../../components/meta-tags-seo/MetaTagsBusinessOwners";
import Sidbarbusiness from "../../../components/business-dashboard/sidbar/Sidbarbusiness";
import HeaderMobile from "../../../components/business-dashboard/sidbar/HeaderMobile";
import Modal from "../../../components/Modal/Modal";
import AlertSuccess from "../../../components/AlertSuccess/AlertSuccess";
// image
import addpic from "../../../images/register-business/add pic.png";

const Businessimage = (props) => {
  const [render, setRender] = useState(false);

  const [dataCome, setDataCome] = useState(false);
  const [disable, setDisable] = useState(false);
  const [base64String, setbase64String] = useState(false);
  const [isApiPhoto, setIsApiPhoto] = useState(false);
  const [apiPhotoUrl, setApiPhotoUrl] = useState("");

  const [selectedImage, setSelectedImage] = useState(null);
  const [showAlert, setshowAlert] = useState(false);

  const [addPicOrDelete, setAddPicOrDelete] = useState("");

  const [progress, setProgress] = useState({}); // for image uplaod progress
  const [imagesList, setImagesList] = useState([]); //to save images list
  const [newImagesList, setNewImagesList] = useState(0); //to save images list
  const [coverId, setCoverId] = useState(null);

  const alertHandeler = () => {
    setshowAlert(true);
    setTimeout(() => {
      setshowAlert(false);
    }, 5000);
  };

  useEffect(() => {
    if (showAlert) {
      setTimeout(() => {
        setshowAlert(false);
      }, 3000);
    }
  }, [showAlert]);

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = React.useState({});

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "business-images",
    Authorization: "Bearer " + getCookie("token"),
  };

  useEffect(() => {
    setDataCome(false);
    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else if (render) {
      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });

      // api to check and get data
      axios
        .get(
          configData.API_DOMAIN +
            `/api/v1/Businesses/${getCookie("BizUuid")}/photos`, // the business Guuid that gets from login
          {
            headers: headerMeta,
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            let data = response.data.data;
            // set data to states
            setDataCome(true);
            if (data.photos.length > 0) {
              setIsApiPhoto(true);
              setApiPhotoUrl(data.photos[0].photoPath);

              setImagesList(data.photos);

              const coverImage = data.photos.find((item) => item.isCover);
              if (coverImage) {
                setCoverId(data.photos.find((item) => item.isCover));
              } else {
                setCoverId(data.photos[0]);
              }
            } else {
              setIsApiPhoto(false);
              setApiPhotoUrl("");
            }
          }
        })
        .catch((error) => {
          // alert(error);
        });
    }
  }, [render]);

  //submit button handler
  const submitHandler = (event) => {
    event.preventDefault();
    setDisable(true);

    for (let index = 0; index < imagesList.length; index++) {
      const element = imagesList[index];

      let formData = new FormData();

      if (element.bpId) {
        // send old photo
        formData.append("Photo", "");
        formData.append(
          "OldPhoto",
          element.photoPath.replace("https://cdn.gishniz.com", "")
        );
        formData.append("BId", getCookie("BizId"));
        formData.append("Id", getCookie("BizUuid"));
        formData.append("BPId", element.bpId);
        formData.append("IsCover", element === coverId);
      } else {
        // if (selectedImage) {
        // set new photo
        if (element) {
          formData.append("Photo", element);
          formData.append("OldPhoto", "new");
          formData.append("BId", getCookie("BizId"));
          formData.append("Id", getCookie("BizUuid"));
          // formData.append("BPId", "");
          formData.append("IsCover", element === coverId);
        } else {
          formData.append(
            "Photo",
            new Blob([], { type: "application/octet-stream" })
          );
          formData.append("OldPhoto", "");
          formData.append("BId", getCookie("BizId"));
          formData.append("Id", getCookie("BizUuid"));
          // formData.append("BPId", "");
          formData.append("IsCover", element === coverId);
        }
        // } else {
        //   // delete photo
        //   formData.append(
        //     "Photo",
        //     new Blob([], { type: "application/octet-stream" })
        //   );
        //   formData.append("OldPhoto", "");
        //   formData.append("BId", getCookie("BizId"));
        //   formData.append("Id", getCookie("BizUuid"));
        // }
      }

      axios
        .post(
          configData.API_DOMAIN +
            `/api/v1/Businesses/${getCookie("BizUuid")}/photos`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
              LangId: 1,
              BizId: getCookie("BizId"),
              Authorization: "Bearer " + getCookie("token"),
            },
            onUploadProgress: (event) => {
              let prog =
                Math.round(100 * event.loaded) / event.total > 0
                  ? Math.round(100 * event.loaded) / event.total
                  : 0;

              if (element.bpId) {
                setProgress((progress) => ({
                  ...progress,
                  [element.bpId]: prog,
                }));
              } else {
                setProgress((progress) => ({
                  ...progress,
                  [element.name]: prog,
                }));
              }
            },
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            // success
            setNewImagesList((newImagesList) => newImagesList + 1);
          }
        })
        .catch((error) => {
          // alert(error);
        });
    }
  };

  useEffect(() => {
    if (newImagesList !== 0 && newImagesList == imagesList.length) {
      alertHandeler();
      setDisable(false);
      setNewImagesList(0);
    }
  }, [newImagesList]);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // convertor to base64 from local (file)
  function encodeImageFileAsURL(element) {
    var file = element.files[0];
    var reader = new FileReader();
    reader.onloadend = function () {
      // console.log("RESULT", reader.result);
      setbase64String(reader.result);
    };
    reader.readAsDataURL(file);
  }

  let windowWidth = "00";
  if (typeof window !== "undefined") {
    // Code that relies on the window object
    windowWidth = window.innerWidth;
  } else {
    windowWidth = "00";
  }

  return (
    <>
      {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

      {windowWidth < 768 ? <HeaderMobile setRender={setRender} /> : ""}
      <div className="margin-0 d-flex bg_business_grey">
        <div className="  d-none d-md-block">
          {windowWidth > 767 ? <Sidbarbusiness setRender={setRender} /> : ""}
        </div>
        <MDBContainer className="bg_business_grey">
          <MDBRow>
            <MDBCol size="12">
              <div>
                <p className="text_img_bus"> گالری عکس</p>
              </div>
              <div className="container_img_bus_content">
                <div>
                  <p className="text_img_bus_content">
                    تصویر کسب‌وکارتان را اضافه کنید
                  </p>
                </div>
                <div className="select_img_business">
                  {dataCome && coverId && (
                    <div className="default-img-div">
                      <span>تصویر پیش‌فرض:</span>
                      <div
                        style={{
                          width: "auto",
                          padding: 0,
                          position: "relative",
                        }}
                      >
                        <img
                          alt="business default image"
                          src={
                            coverId &&
                            (coverId.name
                              ? URL.createObjectURL(coverId)
                              : coverId.photoPath)
                          }
                        />
                      </div>
                    </div>
                  )}

                  {dataCome ? (
                    <MDBContainer fluid className="mt-3 centerr p-0">
                      <MDBRow className="div-drop-container div-drop-container2">
                        <label
                          className={
                            disable ||
                            imagesList.length >
                              configData.Business_Photo_Number - 1
                              ? "drop-container drop-container-disabled me-3 ms-4"
                              : "drop-container me-3 ms-4"
                          }
                        >
                          <img src={addpic} alt="add" className="img-upload" />
                          <input
                            type="file"
                            id="images"
                            accept="image/*"
                            onChange={(event) => {
                              setSelectedImage(event.target.files[0]);
                              encodeImageFileAsURL(event.target);
                              setIsApiPhoto(false);

                              if (
                                !imagesList.find(
                                  (item) =>
                                    item.name == event.target.files[0].name
                                )
                              ) {
                                if (!coverId && imagesList.length == 0) {
                                  setCoverId(event.target.files[0]);
                                }
                                setImagesList((items) => [
                                  ...items,
                                  event.target.files[0],
                                ]);
                              }
                            }}
                            disabled={
                              disable ||
                              imagesList.length >
                                configData.Business_Photo_Number - 1
                            }
                            required
                          />
                        </label>

                        {imagesList.length > 0 &&
                          imagesList.map((item, index) => (
                            <>
                              <div
                                style={{
                                  width: "auto",
                                  padding: 0,
                                  position: "relative",
                                  marginTop: "12px",
                                }}
                                onClick={() => setCoverId(item)}
                              >
                                <img
                                  id="imageid"
                                  alt="business image"
                                  src={
                                    item.name
                                      ? URL.createObjectURL(item)
                                      : item.photoPath
                                  }
                                  className={
                                    disable
                                      ? "uploaded_img uploaded_img_disable"
                                      : coverId && coverId === item
                                      ? "uploaded_img uploaded_img_cover"
                                      : "uploaded_img"
                                  }
                                />

                                {/* spinner */}
                                {disable && (
                                  <Box
                                    sx={{
                                      position: "absolute",
                                      display: "inline-flex",
                                      left: "10%",
                                      top: "35%",
                                      width: "71px",
                                    }}
                                  >
                                    <CircularProgress
                                      variant="determinate"
                                      {...{
                                        value: item.bpId
                                          ? progress[item.bpId]
                                          : progress[item.name],
                                      }}
                                      sx={{ color: "#005589", zIndex: 2 }}
                                    />
                                    <CircularProgress
                                      variant="determinate"
                                      sx={{
                                        color: "#a9a9a9",
                                        zIndex: 1,
                                        position: "absolute",
                                      }}
                                      {...{
                                        value: item.bpId
                                          ? progress[item.bpId]
                                          : progress[item.name],
                                      }}
                                      value={100}
                                    />
                                    <Box
                                      sx={{
                                        top: 0,
                                        left: 0,
                                        bottom: 0,
                                        right: "-35px",
                                        position: "relative",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Typography
                                        variant="caption"
                                        component="div"
                                        color="text.secondary"
                                        sx={{
                                          width: "31px",
                                        }}
                                      >
                                        {`${Math.round(
                                          item.bpId
                                            ? progress[item.bpId]
                                              ? progress[item.bpId]
                                              : 0
                                            : progress[item.name]
                                            ? progress[item.name]
                                            : 0
                                        )}%`}
                                      </Typography>
                                    </Box>
                                  </Box>
                                )}
                                {/* spinner */}
                              </div>

                              <div className="ms-5 business-dropdown img_bus_content d-md mb-0">
                                <MDBBtn
                                  disabled={disable}
                                  className="mx-1 btn-upload-img business-dropbtn"
                                >
                                  <Modal
                                    deleteItem={item}
                                    imagesList={imagesList}
                                    setImagesList={setImagesList}
                                    setAddPicOrDelete={setAddPicOrDelete}
                                    alertHandeler={alertHandeler}
                                    text={"آیا میخواهید این عکس حذف شود؟"}
                                    setProgress={setProgress}
                                    coverId={coverId}
                                    setCoverId={setCoverId}
                                  />
                                </MDBBtn>
                                <div className="position-relative">
                                  <div className="business-dropdown-content business-dropdown-content-dash-bus">
                                    <a className=" bdi-lastt">حذف تصویر</a>
                                  </div>
                                </div>
                              </div>
                            </>
                          ))}
                      </MDBRow>
                    </MDBContainer>
                  ) : (
                    <MDBContainer fluid className="mt-3 centerr p-0">
                      <MDBRow className="div-drop-container div-drop-container2">
                        <Skeleton
                          className="Skeleton-s7 me-3"
                          variant="rectangular"
                          width={126}
                          height={126}
                          animation="wave"
                        />{" "}
                        <Skeleton
                          className="Skeleton-s7"
                          variant="rectangular"
                          width={126}
                          height={126}
                          animation="wave"
                        />{" "}
                      </MDBRow>
                    </MDBContainer>
                  )}
                </div>
                <div className="step2_save_c">
                  {dataCome ? (
                    <button
                      onClick={submitHandler}
                      disabled={disable}
                      className="btn_information_submit"
                    >
                      ذخیره اطلاعات
                    </button>
                  ) : (
                    <Skeleton
                      className="btn_information_submit me-auto"
                      variant="rectangular"
                      height={39}
                      animation="wave"
                    />
                  )}
                </div>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
      <AlertSuccess
        showAlert={showAlert}
        text={
          addPicOrDelete == "delete"
            ? "عکس شما با موفقیت حذف شد ."
            : "تصاویر شما با موفقیت ذخیره شدند ."
        }
      />
    </>
  );
};

export default Businessimage;
